import React from "react";
import InputAutocomplete from "./autocomplete";
import InputCheckbox from "./checkbox";
import InputDate from "./date";
import InputSelect from "./select";
import InputText from "./text";

const CreateInput = (props) => {
  const { data_key, data_type, select_items_name, multiline, readonly } =
    props.data;

  switch (data_type) {
    case "input":
      return (
        <InputText
          value={props.data_array[data_key]}
          data_key={data_key}
          multiline={multiline}
          readonly={readonly}
          Change_Data={props.Change_Data}
        />
      );
    case "select":
      return (
        <InputSelect
          value={props.data_array[data_key]}
          data_key={data_key}
          Change_Data={props.Change_Data}
          list={props.list[select_items_name]}
        />
      );
    case "autocomplete":
      return (
        <InputAutocomplete
          value={props.data_array[data_key]}
          data_key={data_key}
          Change_Data={props.Change_Data}
          options={props.list[select_items_name]}
        />
      );
    case "datum":
      return (
        <InputDate
          value={props.data_array[data_key]}
          data_key={data_key}
          Change_Data={props.Change_Data}
        />
      );
    case "checkbox":
      return (
        <InputCheckbox
          value={props.data_array[data_key]}
          data_key={data_key}
          Change_Data={props.Change_Data}
        />
      );
    default:
  }
};

export default CreateInput;
